import React, { Component } from 'react';
import { Link } from 'react-router-dom';

class Paragliding extends Component {
	render() {
		return (
			<div className='row' style={styles.container}>
				<div className='col-xs-12 col-sm-12 col-md-offset-3 col-md-6 col-lg-offset-4 col-lg-4'>
					<div className='panel panel-default'>
						<div className='panel-heading' style={{textAlign: 'center'}}>
							<Link to='/' className='pull-left' style={styles.back}>
								<span className='glyphicon glyphicon-chevron-left'></span>
							</Link>
							Paragliding
						</div>
						<div className='panel-body'>
							coming soon ...
						</div>
					</div>
				</div>
			</div>
		)
	}
}

export default Paragliding;

const styles = {
	container: {
		margin: '10px 0px 30px 0px'
	},
	link: {
		fontSize: '1.5em',
		textDecoration: 'none',
		color: '#000'
	},
	back: {
		color: '#000',
		textDecoration: 'none'
	}
}



// WEBPACK FOOTER //
// ./src/Paragliding.js